import { cn } from '@spiaggeit/spit-ui'
import { useEffect } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import { useAppDispatch, useAppSelector } from '@/hooks/store.ts'
import { appSlice } from '@/store/appSlice.ts'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { BREAKPOINTS } from '@/utils/breakpoints.ts'

import { Minus } from '../../assets/icons/Minus.tsx'
import { Plus } from '../../assets/icons/Plus.tsx'
import { LegendDialog } from '../../routes/Map/LegendDialog.tsx'

import { CartMobileSheet } from './CartMobileSheet/CartMobileSheet.tsx'
import { CartOverview } from './CartOverview/CartOverview.tsx'

interface Props {
  zoomIn?(): void
  zoomOut?(): void
  nextPath?: string
  className?: string
}

export const CartFooter = (props: Props) => {
  const cartItems = useAppSelector(cartSlice.selectors.items)
  const cartItemsLength = Object.keys(cartItems).length
  const dispatch = useAppDispatch()
  const cartPopoverIsOpen = useAppSelector(
    cartSlice.selectors.cartPopoverIsOpen
  )
  const isKiosk = useAppSelector(appSlice.selectors.isKiosk)
  const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS.lg}px)`)

  useEffect(() => {
    if (cartItemsLength < 1) {
      setTimeout(() => {
        dispatch(cartSlice.actions.setCartPopoverIsOpen(false))
      }, 200)
    }
  }, [dispatch, cartItemsLength])

  useEffect(() => {
    dispatch(cartSlice.actions.setCartPopoverIsOpen(false))
  }, [])

  return (
    <footer
      className={cn(
        'sticky bottom-0 z-10 mt-auto bg-white py-4 shadow-inverted',
        { 'rounded-none': cartPopoverIsOpen },
        props.className
      )}
    >
      <div
        className={cn('flex gap-4', {
          container: !isKiosk,
          'px-4': isKiosk,
        })}
      >
        {!isDesktop ? <CartMobileSheet nextPath={props.nextPath} /> : null}

        {!isKiosk && props.zoomIn && props.zoomOut ? (
          <div className="hidden items-center gap-4 lg:flex">
            <div className="flex items-center gap-2">
              <button
                className="flex size-10 select-none items-center justify-center rounded-sm border bg-white text-primary transition-colors duration-200 hover:border-gray-300"
                onClick={props.zoomOut}
                type="button"
              >
                <Minus className="size-5" />
              </button>

              <button
                className="flex size-10 select-none items-center justify-center rounded-sm border bg-white text-primary transition-colors duration-200 hover:border-gray-300"
                onClick={props.zoomIn}
                type="button"
              >
                <Plus className="size-5" />
              </button>
            </div>

            <LegendDialog />
          </div>
        ) : null}

        <CartOverview nextPath={props.nextPath} />
      </div>
    </footer>
  )
}
